import { NgModule } from '@angular/core';


import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [],
  imports: [CoreModule],
  exports: [CoreModule]
})

export class NgxKeycloakAuthzLibModule { }
